import { z } from "zod";
export const analyzedComponentSchema = z.object({
    description: z.string().min(1).max(200),
    estimatedKarat: z.number().int().min(1).max(24),
    estimatedWeightGrams: z.number().nonnegative().max(10_000),
    confidence: z.number().min(0).max(1),
    boundingBox: z
        .object({
        x: z.number().min(0).max(1),
        y: z.number().min(0).max(1),
        width: z.number().min(0).max(1),
        height: z.number().min(0).max(1),
    })
        .optional(),
});
export const analyzedItemSchema = z.object({
    label: z.string().min(1).max(200),
    components: z.array(analyzedComponentSchema).max(50),
});
export const analyzeImageSchema = z.object({
    storagePath: z.string().min(1).max(500),
    itemId: z.string().min(1).optional(),
});
export const kioskAnalyzeSchema = z.object({
    storagePath: z.string().min(1).max(500),
});
export const kioskImageUploadSchema = z.object({
    mimeType: z.enum(["image/jpeg", "image/png", "image/webp"]),
    imageBase64: z.string().min(1).max(12_000_000),
});
export const analyzeImageResponseSchema = z.object({
    items: z.array(analyzedItemSchema),
    analysisSkipped: z.boolean().optional(),
    skippedReason: z.string().optional(),
});
export const kioskImageUploadResponseSchema = z.object({ storagePath: z.string() });
